import React, {useEffect, useRef} from "react"
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from "@material-ui/core/MenuItem";
import NumberFormat from 'react-number-format';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import {Tooltip, withStyles} from "@material-ui/core";
import downloadIcon from "../images/figma/arrow_download.svg";
import {GenerateImagePath} from "../services/GenerateImagePath";
import GenerateProductList from "../services/GenerateProductListService";
import KnxGenerateProjectService from "../services/knx_ausstattung/GenerateProjectService";
import EasyGenerateProjectService from "../services/easy_ausstattung/GenerateProjectService";
import KonventionellGenerateProjectService from "../services/konventionell_ausstattung/GenerateProjectService";
import products from "../data/products.json";
import {ProjectSaveService} from "../services/ProjectSaveService";
import ProductSelectSwitchComponent from "./ProductSelectSwitchComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import radioUnchecked from "../images/figma/radio_unchecked.svg"
import radioChecked from "../images/figma/radio_checked.svg"
import {ExpandMoreOutlined} from "@material-ui/icons";
import iIcon from "../images/info_icon.svg";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import gaEventTracker from "../services/gaEventTracker";
import gaPageTracker from "../services/gaPageTracker";
import GetAusstattungProduktObj from "../services/AusstattungProduktService";
import initialProjectData from "../data/initialProjectData.json";

export default function StepSixComponent({project, updateProject, isExpert, isExpertForSave, updateQueryParams, saveIdTracking, trackingObj, equipmentData2, equipmentData4}){

    const [selectedRoomFilter, setSelectedRoomFilter] = React.useState();
    const [selectedProductFilter, setSelectedProductFilter] = React.useState();
    const [foerderung1, setFoerderung1] = React.useState(true);
    const [foerderung2, setFoerderung2] = React.useState(false);
    const [foerderung3, setFoerderung3] = React.useState(false);
    const [loadingCSV, setLoadingCSV] = React.useState(false);
    // const [loadingCSV2, setLoadingCSV2] = React.useState(false);
    const [loadingRoomBook, setLoadingRoomBook] = React.useState(false);
    const [inClipboard, setInClipboard] = React.useState(false);
    const [planungsCode, setPlanungsCode] = React.useState(null);
    const [openedRooms, setOpenedRooms] = React.useState([]);
    const [openedGroups, setOpenedGroups] = React.useState([]);
    const [saveProjectTypeChange, setSaveProjectTypeChange] = React.useState(false);
    let callFunction = '';
    let pCode = null;
    let pCodeInterval = 0;
    const [noticeDialogOpen, setNoticeDialogOpen] = React.useState(false);
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
    const scrollToElementRef = useRef(null);

    useEffect(openNoticeDialog, []);
    useEffect(saveTrackingInfo, []);
    function openNoticeDialog() {
        if (project.showStep6Modal) {
            setNoticeDialogOpen(true);
            updateProject({...project, showStep6Modal: false});
        }
    }
    function handleNoticeDialogButton() {
        scrollToElementRef.current.scrollIntoView({behavior: "smooth"});
        setNoticeDialogOpen(false);
    }
    function handleNoticeDialogClose() {
        setNoticeDialogOpen(false);
    }
    function updateProjectLocal(projectIn){
        // setPlanungsCode(null);
        if (projectIn.projectType === 'easy') { saveIdTracking('ob_configuration_type', 'ob_configuration_knx_easy'); }
        else {
            saveIdTracking('ob_configuration_type', 'ob_configuration_knx_ets');
            const austattung_produkt = GetAusstattungProduktObj(projectIn, projectIn.floors[0].rooms[0]);
            const dalis = ["dali-gateway-2fach", "dali-gateway-1fach"];
            if (projectIn.selectedAlternatives !== undefined) {
                let found = false;
                Object.keys(projectIn.selectedAlternatives).map(key => {
                    if (key.indexOf('dali-option') >= 0) {
                        projectIn = {
                            ...projectIn,
                            selectedAlternatives: {
                                ...projectIn.selectedAlternatives,
                                [key]: key
                            }
                        };
                        found = true;
                    }
                });
                if (!found) {
                    dalis.forEach(dali => {
                        const key = 'dali-option|' + austattung_produkt[dali]
                        projectIn = {
                            ...projectIn,
                            selectedAlternatives: {
                                ...projectIn.selectedAlternatives,
                                [key]: key
                            }
                        };
                    });
                }
            } else {
                dalis.forEach(dali => {
                    const key = 'dali-option|' + austattung_produkt[dali]
                    projectIn = {
                        ...projectIn,
                        selectedAlternatives: {
                            ...projectIn.selectedAlternatives,
                            [key]: key
                        }
                    };
                });
            }
        }
        // console.log('switched type', projectIn)
        updateProject(projectIn);
        setSaveProjectTypeChange(true);
    }

    function useProjectService(projectIn){
        if(project.generatedProject !== undefined){
            return project;
        }
        switch(projectIn.projectType){
            case "knx":
                return KnxGenerateProjectService(projectIn, products);
            case "easy":
                return EasyGenerateProjectService(projectIn, products);
            case "konventionell":
                return KonventionellGenerateProjectService(projectIn, products);
            default:
                return project;
        }
    }
    const currentProject = useProjectService(project);

    var productListAndFilters = GenerateProductList(currentProject, selectedRoomFilter, selectedProductFilter);

    let calculatedValues = calculatePrices(products);
    let nettopreis = calculatedValues[0];
    let gesamtsummeohnebeg = calculatedValues[4];
    let mwst = calculatedValues[1];
    let beg = calculatedValues[2];
    let gesamtsumme = calculatedValues[3];
    const totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
    const usedProducts = [];
    productListAndFilters.productList.forEach(group => {
        group.products.forEach(product => {
            usedProducts.push({itemNumber: product.Artikelnummer, itemName: product.Bezeichnung, itemCount: product.count, uvp: product.Preis});
        });
    });
    if (saveProjectTypeChange) {
        const finalStepData = trackingObj ? getFinalStepTracking() : null;
        if (finalStepData) {
            ProjectSaveService.saveTracking({
                trackingId: trackingObj.trackingId,
                projectType: project.projectType,
                finalStep: finalStepData,
            }, undefined, trackingObj);
            setSaveProjectTypeChange(false);
        }
    }

    function saveTrackingInfo() {
        const finalStepData = trackingObj ? getFinalStepTracking() : null;
        // console.log('saveTrackingInfo', project, finalStepData, trackingObj)
        if (project?.loadedFromCode && trackingObj) {
            let projectType = project.projectType;
            const loadedApartmentType = initialProjectData[project.selectedMusterIx].name;
            ProjectSaveService.saveTracking({
                trackingId: trackingObj.trackingId,
                finalStep: finalStepData,
                // saved: finalStepData,
                loadedAmount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
                step: project.isExpert ? 6 : 5,
                apartmentType: loadedApartmentType,
                b2b: project.isExpert ? true : false,
                projectType,
            }, undefined, trackingObj);
        } else if (trackingObj) {
            ProjectSaveService.saveTracking({
                trackingId: trackingObj.trackingId,
                finalStep: Object.assign(finalStepData, {
                    amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
                    usedProducts: usedProducts
                }),
                step: project.isExpert ? 6 : 5,
                b2b: project.isExpert ? true : false,
                loadedAmount: null
            }, undefined, trackingObj);
        }
    }

    function getFinalStepTracking() {
        let data = Object.assign(trackingObj.finalStep || {}, {
            amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
            usedProducts: usedProducts,
            constructionProjectType : project.subProjectType || "neubau"
        });
        // step1 data
        if (project.selectedMusterIx !== undefined && project.selectedMusterIx !== null) {
            data = Object.assign(data, {apartmentType: initialProjectData[project.selectedMusterIx].name});
        }
        // step2 Data
        const levelName = project.selectedLevel > 2 ? 'Premium' : (project.selectedLevel > 1 ? 'Komfort' : 'Basic');
        data = Object.assign(data,{scopeOfEquipment: levelName});
        let selectedEquipments = [];
        project.floors.forEach(floor => {
            floor.rooms.forEach(room => {
                equipmentData2.forEach(ed => {
                    ed.options.forEach(opt => {
                        const found = selectedEquipments.filter(i => i.name === opt.name)[0];
                        let eq;
                        if (found) {
                            eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
                        } else if (room.selectedEquipment[opt.id]) {
                            eq = {name: opt.name, count: parseInt(room.selectedEquipment[opt.id],10)};
                        }
                        if (eq) { selectedEquipments = [...selectedEquipments.filter(i => i.name !== opt.name), eq]; }
                    });
                });
            });
        });
        data = Object.assign(data || {}, {selectedEquipments: selectedEquipments});
        // step3 data
        let deviceSeries = [];
        project.floors.forEach(fl => {
            fl.rooms.forEach(room => {
                const serie = {
                    name: room.selectedDesign.selectedSerie.name || '',
                    operatingConcept: room.selectedDesign.selectedOperationConcept?.name || '',
                    color: room.selectedDesign.selectedColor1.colorName || ''
                };
                const found = deviceSeries.filter(i => i.name === serie.name && i.operatingConcept === serie.operatingConcept && i.color === serie.color)[0];
                // if (found) {
                //     deviceSeries = [...deviceSeries.filter(i => i.name !== serie.name || i.operatingConcept !== serie.operatingConcept || i.color !== serie.color), {...found, count: found.count + 1}];
                // } else {
                //     deviceSeries = [...deviceSeries, {...serie, count: 1}];
                // }
                deviceSeries = found ? [...deviceSeries] : [...deviceSeries, {...serie, count: 1}];
            });
        });
        data = Object.assign(data, {deviceSeries: deviceSeries});
        // step4 Data
        let selectedOptions = [];
        equipmentData4.forEach(ed => {
            if (ed.selectableFor === 'project') {
                ed.options.forEach(opt => {
                    const found = selectedOptions.filter(i => i.name === opt.id)[0];
                    let eq;
                    if (found) {
                        eq = Object.assign(found, {count: found.count + parseInt(project.selectedEquipment[opt.id] || 0,10)});
                    } else if (project.selectedEquipment[opt.id]) {
                        eq = {name: opt.id, count: parseInt(project.selectedEquipment[opt.id],10)};
                    }
                    if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
                });
            } else {
                project.floors.forEach(floor => {
                    floor.rooms.forEach(room => {
                        ed.options.forEach(opt => {
                            const found = selectedOptions.filter(i => i.name === opt.id)[0];
                            let eq;
                            if (found) {
                                eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
                            } else if (room.selectedEquipment[opt.id]) {
                                eq = {name: opt.id, count: parseInt(room.selectedEquipment[opt.id],10)};
                            }
                            if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
                        });
                    });
                });
            }
        });
        data = Object.assign(data || {}, {selectedOptions: selectedOptions});

        return data;
    }

    function selectProductFilterValue(item, allRoomsItem = undefined){
        if (!allRoomsItem) { setSelectedProductFilter(item); return; }
        saveIdTracking('ob_article_list_setting', 'ob_article_list_setting_per_category');
        productListAndFilters = {
            ...productListAndFilters,
            roomFilters: productListAndFilters.roomFilters.map(rf => rf.map(roomFilter => {
                if (roomFilter.key !== allRoomsItem.key) { return roomFilter; }
                setSelectedProductFilter({
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                });
                return {
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                };
            }))
        };
        setSelectedRoomFilter({floor: 'all', room: productListAndFilters.roomFilters});
    }
    function selectRoomFilerValue(floor, room){
        saveIdTracking('ob_article_list_setting', 'ob_article_list_setting_per_room');
        if(floor !== undefined && room !== undefined) {
            setSelectedRoomFilter({floor: floor.id, room: room.id});
        }else if (floor !== undefined && room === undefined){
            setSelectedRoomFilter({floor: floor.id});
        }else if (floor === undefined && room === 'all') {
            setSelectedRoomFilter({floor: 'all', room: productListAndFilters.roomFilters})
        }else{
            setSelectedRoomFilter({floor: undefined, room: undefined});
        }
    }
    function generateRoomFilter(roomFilterList){
        const list = [];
        list.push(<MenuItem value="alle" key={"alle"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, undefined)}>Stückliste Produktebene</MenuItem>)
        list.push(<MenuItem value="all" key={"all"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, 'all')}>Stückliste Raumebene</MenuItem>)
        roomFilterList.forEach( f=>{
            list.push(<ListSubheader value={f.id} key={f.id} style={{fontSize:"inherit"}} className={"roomFilterFloorItem"} onClick={e => selectRoomFilerValue(f)}>{f.name}</ListSubheader>)
            f.rooms.forEach(r => list.push(<MenuItem value={r.id} key={r.id} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(f, r)}>{r.name}</MenuItem>))
        });
        return list;
    }
    function generateProductFilter(catFilterList, allRoomsItem = undefined){
        const list = [];
        if (!allRoomsItem) {
            list.push(<MenuItem value={"productFilter-all"} key={"productFilter-all"} style={{fontSize: "inherit"}} className={"productFilterItem"} onClick={e => selectProductFilterValue(undefined)}>Alle Produkte</MenuItem>);
            catFilterList.forEach((item) =>
                list.push(<MenuItem value={"productFilter-" + item.id} key={"productFilter-" + item.id}
                                    style={{fontSize: "inherit"}} className={"productFilterItem"}
                                    onClick={e => selectProductFilterValue(item.id)}>{item.name}</MenuItem>)
            );
        } else {
            list.push(<MenuItem value={"all"} key={"all"} style={{fontSize: "inherit"}} className={"productFilterItem"} onClick={e => selectProductFilterValue(undefined, {key: allRoomsItem.key, productFilter: undefined})}>Alle Produkte</MenuItem>);
            allRoomsItem.catFilterList.forEach((item) =>
                list.push(<MenuItem value={item.id} key={item.id}
                                    style={{fontSize: "inherit"}} className={"productFilterItem"}
                                    onClick={e => selectProductFilterValue(
                                        item.id, {key: allRoomsItem.key, productFilter: item.id}
                                    )}>{item.name}</MenuItem>)
            );
        }
        return list;
    }
    const ColorButton4 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--color1)",
            '&:hover': {
                backgroundColor:"var(--color1)",
            },
            // border: "1px solid var(--schwarz)",
            borderRadius: 0,
            // width: "143px",
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            // margin: "20px",
            padding: "10px",
            flex: 1,
            textTransform: "inherit",
            maxWidth: project.isExpert ? null : '33%'
        },
    }))(Button);
    function onOpenCloseGroup(name) {
        const found = openedGroups.filter(i => i.name === name && i.opened === true)[0];
        if (found) {
            setOpenedGroups([...openedGroups.filter(i => i.name !== name), {name: name, opened: false}]);
        } else {
            setOpenedGroups([...openedGroups, {name: name, opened: true}]);
        }
    }
    function generateGroupList(productList = undefined){
        const list = [];
        if (!productList) {
            productListAndFilters.productList.forEach((g, idx) => {
                if (idx === 0 && openedGroups.filter(i => i.name === g.name)[0] === undefined) {
                    setOpenedGroups([...openedGroups, {name: g.name, opened: true}]);
                }
                if (selectedProductFilter === undefined || selectedProductFilter === g.name) {
                    const subHeader = getCategorieSubHeader(g.name);
                    const opened = openedGroups.filter(i => i.name === g.name && i.opened === true)[0];
                    list.push(<div className={"group" + (!opened ? " closed" : "")} key={g.name}>
                        <div className={"tableHeader row"} style={{padding: subHeader !== "" ? (opened ? "0" : "15px 0") : "15px 0", position: "relative", alignItems: "center", marginTop: (opened ? '20px' : '-10px')}}>
                            <div className="col-4 section-title">
                                <div className="openClose step6" onClick={e => {onOpenCloseGroup(g.name)} }>
                                    {opened !== undefined ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon /> }
                                </div>
                                {g.name}
                            </div>
                            <div className="text-right col-2">{opened ? "Art. Nr." : ""}</div>
                            <div className="text-right col-2">{opened ? "UVP" : ""}</div>
                            <div className="text-right col-2">{opened ? "Anzahl" : ""}</div>
                            <div className="text-right col-2">{opened ? "Summe" : ""}</div>
                        </div>
                        {opened ? <div className={subHeader !== "" ? "section-sub-title" : "groupSubHeader hidden"}>{subHeader}</div> : null}
                        <div className={"groupContent"}>{opened ? generateProduktListForGroup(g.products) : null}</div>
                    </div>)
                }
            });
        } else {
            productList.forEach(g => {
                if (g.products.length) {
                    const subHeader = getCategorieSubHeader(g.name);
                    list.push(<div className={"group"} key={g.name}>
                        <div className={"tableHeader row"} style={{padding: subHeader !== "" ? "15px 0 0" : "15px 0"}}>
                            <div className="col-4 section-title">{g.name}</div>
                            <div className="text-right col-2">Art. Nr.</div>
                            <div className="text-right col-2">UVP</div>
                            <div className="text-right col-2">Anzahl</div>
                            <div className="text-right col-2">Summe</div>
                        </div>
                        <div className={subHeader !== "" ? "section-sub-title" : "groupSubHeader hidden"}>{subHeader}</div>
                        <div className={"groupContent"}>
                            {
                                generateProduktListForGroup(g.products)
                            }
                        </div>
                    </div>)
                }
            });
        }

        return list;
    }
    function generatePListForRoom(g) {
        const list = [];
        g.products.forEach(pr => {
            list.push(<div className={"row"} key={pr.Artikelnummer}>
                <div className="col-6" key={pr.Artikelnummer}>
                    <div className={"row noborder"} style={{maxHeight: "50px"}}>
                        <div className={"col-1"} style={{minWidth: "50px"}}>
                            <img src={GenerateImagePath.getPath(pr.Artikelnummer, "JUNG_")} alt=""
                                 style={{maxWidth: "50px", maxHeight: "50px"}}/>
                        </div>
                        <div className={"col-10 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                        <div className={"col-1 artNr"}
                             style={{padding: "0 0px", textAlign: "right"}}>{pr.Artikelnummer}</div>
                    </div>
                </div>
                <div className="text-right col-2"><NumberFormat value={(pr.Preis / 100)}
                                                                displayType={'text'} suffix={" €"}
                                                                thousandSeparator={"."}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                decimalSeparator={","}/></div>
                <div className="text-right col-2">{pr.count}</div>
                <div className="text-right col-2"><NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                displayType={'text'} suffix={" €"}
                                                                thousandSeparator={"."}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                decimalSeparator={","}/></div>
            </div>);
        });
        if (!g.products.length) { list.push(<div className={"row"}>Keine Produkte</div>);}
        return list;
    }
    function onOpenClose(ridx) {
        const found = openedRooms.filter(i => i.idx === ridx)[0];
        if (found) {
            const orooms = openedRooms.map(r => r.idx === ridx ? {...r, opened: !r.opened} : r);
            setOpenedRooms(orooms);
        } else {
            const orooms = [...openedRooms];
            orooms.push({idx: ridx, opened: true});
            setOpenedRooms(orooms);
        }
    }
    function GetRLR(g, r, rIdx) {
        const opened = openedRooms.filter(i => i.idx === rIdx && i.opened === true)[0];
        return <div className={"room-container" + (!opened ? " closed" : "")} key={g.name + ' - ' + r.name}>
            <div className={"groupHeader"}>
                <div className={"tableHeader row"} style={{padding: "15px 0", position: "relative", alignItems: "center"}}>
                    <div className="openClose step6" onClick={e => {onOpenClose(rIdx)} }>
                        {opened !== undefined ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon /> }
                    </div>
                    <div className="col-5 section-title">{g.name} - {r.name}</div>
                    <div className="text-right col-1">{opened ? "Art. Nr." : ""}</div>
                    <div className="text-right col-2">{opened ? "UVP" : ""}</div>
                    <div className="text-right col-2">{opened ? "Anzahl" : ""}</div>
                    <div className="text-right col-2">{opened ? "Summe" : ""}</div>
                </div>
            </div>
            <div className={"groupContent"}>{opened !== undefined ? generatePListForRoom(r) : null}</div>
        </div>;
    }
    function GetRLRGroup(g) {
        const list = [];
        g.rooms.forEach((room, idx) => {
            if (idx === 0) {
                if (openedRooms.filter(i => i.idx === idx)[0] === undefined) {
                    setOpenedRooms([...openedRooms, {idx: idx, opened: true}]);
                }
            }
            if (room.products && room.products.length) {
                list.push(GetRLR(g, room, idx));
            }
        });
        return list;
    }
    function GetRoomListRoom(props) {
        const list = [];
        const roomFilterList = props.value;
        roomFilterList.forEach( g => {
            list.push(<div className={"floor-container"} key={g.name}>
                {GetRLRGroup(g)}
            </div>);
        });
        if (!list.length) { list.push(<div className={"row"} style={{margin: "15px 0"}}>Keine Produkte</div>); }
        return list;
    }
    function generateRoomList() {
        const list = [];
        list.push(<GetRoomListRoom key={'the-room-list'} value={productListAndFilters.roomFilterList} />);
        return list;
    }
    function getCategorieSubHeader(name) {
        let retVal = "";
        switch (name) {
            case "Rahmen": retVal = "Hinweis: „Die Rahmenausrichtung ist auf die örtliche Gegebenheit mit dem Elektrofachpartner abzustimmen“"; break;
            default: break;
        }
        return retVal;
    }

    function generateProduktListForGroup(products){
        const list = [];
        products.forEach(p => {
                list.push(<div className={"row"} key={p.Artikelnummer}>
                    <div className="col-6" key={p.Artikelnummer}>
                        <div className={"row noborder"} style={{maxHeight: "50px"}}>
                            <div className={"col-1"} style={{minWidth: "50px"}}>
                                <img src={GenerateImagePath.getPath(p.Artikelnummer)} alt="" style={{maxWidth: "50px", maxHeight: "50px"}}/>
                            </div>
                            <div className={"col-10 productName"} style={{padding: "0 30px"}}>{p.Bezeichnung}{isExpert ? <><br/><ProductSelectSwitchComponent list={p.productSwitch} project={project} updateProject={updateProject}/></> : null}</div>
                            <div className={"col-1 artNr"} style={{padding: "0 0px", textAlign: "right"}}>{p.Artikelnummer}</div>
                        </div>
                    </div>
                    <div className="text-right col-2"><NumberFormat value={(p.Preis / 100)}
                                                                    displayType={'text'} suffix={" €"}
                                                                    thousandSeparator={"."}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    decimalSeparator={","}/></div>
                    <div className="text-right col-2">{p.count}</div>
                    <div className="text-right col-2"><NumberFormat value={(p.Preis / 100) * p.count}
                                                                    displayType={'text'} suffix={" €"}
                                                                    thousandSeparator={"."}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    decimalSeparator={","}/></div>
                </div>);
        })
        return list.length > 0 ? list : <div className={"row"}>Keine Produkte</div>
    }

    function calculatePrices(begProductList){

        let produktpreis = 0;
        let nettopreis = 0;
        let mwst = 0;
        let beg = 0;
        let gesamtsumme = 0;
        productListAndFilters.productList.forEach( g => {
            g.products.forEach(p => {
                nettopreis += (p.Preis*p.count);
                mwst += ((p.Preis*0.19)*p.count);
                produktpreis = p.Preis*1.19;
                if(foerderung1 === true && foerderung2 === true && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.6;
                        beg += (produktpreis*p.count)*0.4;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.75;
                        beg += (produktpreis*p.count)*0.25;
                    }else if(product['BEG-20'] === 0 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis * p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-20'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.75;
                        beg += (produktpreis*p.count)*0.25;
                    }else if(product['BEG-20'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === true && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.65;
                        beg += (produktpreis*p.count)*0.35;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.8;
                        beg += (produktpreis*p.count)*0.2;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if((product['BEG-20'] === 1 && currentProject.projectType === 'knx')
                        || (product['BEG-20'] === 1 &&currentProject.projectType === 'easy')){
                        gesamtsumme += (produktpreis * p.count)*0.8;
                        beg += (produktpreis*p.count)*0.2;
                    }else if(currentProject.projectType === 'konventionell'){
                        gesamtsumme += (produktpreis*p.count);
                    }else{
                      gesamtsumme += produktpreis*p.count;
                    }
                }
            })
        })

        nettopreis = nettopreis / 100;
        mwst = mwst / 100;
        beg = beg / 100;
        gesamtsumme = gesamtsumme / 100;
        produktpreis = nettopreis * 1.19;

        nettopreis = round(nettopreis);
        mwst = round(mwst);
        beg = round(beg);
        gesamtsumme = round(gesamtsumme);
        produktpreis = round(produktpreis);

        return [nettopreis, mwst, beg, gesamtsumme, produktpreis];
    }

    function round(number){
        let num = Number((Math.abs(number) * 100).toPrecision(15));
        let finalNumber = Math.round(num) / 100 * Math.sign(number);
        finalNumber = finalNumber.toFixed(2);
        finalNumber = finalNumber.replace("." , ",");
        finalNumber = finalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return finalNumber;
    }

    function keineUmlaute(text){
        text = text.replace(/ä/gi, "ae");
        text = text.replace(/ö/gi, "oe");
        text = text.replace(/ü/gi, "ue");
        text = text.replace(/ß/gi, "ss");
        return text;
    }

    function checkCode() {
        if (planungsCode || pCode) {
            downloadPdf();
            clearInterval(pCodeInterval);
        }
    }

    function downloadPdf(){
        setLoadingRoomBook(true);
        if (!planungsCode && !pCode) {
            pCodeInterval = setInterval(checkCode, 500);
            saveProject();
            return;
        }
        saveIdTracking('btn_project_cta', 'btn_project_get_room_book');
        let projectRooms = [];

        if(project.floors !== undefined){
            project.floors.forEach( g => {
                if(g.rooms !== undefined) {
                    projectRooms.push(g);
                }
            })
        }
        let categories = [];
        if (productListAndFilters.isAllRooms) {
            productListAndFilters.roomFilterList.forEach(g => {
                g.rooms.forEach(r => {
                    if (r.products && r.products.length) {
                        categories.push({
                            name: g.name + " - " + r.name,
                            products: r.products.map(p => { return {...p, kategorie: g.name + " - " + r.name}; })
                        });
                    }
                });
            });
        } else {
            categories = productListAndFilters.productList;
        }
        const nr = parseFloat(calculatedValues[3].replace('.','').replace('.','').replace(',','.'));
        const mwstNr = round((nr * 19) / 119);
        calculatedValues.push(mwstNr);
        const products = JSON.stringify(
            {
                name: project.projectName || project.name,
                projectType: project.projectType,
                productCategories: categories,
                foerderung_1: foerderung1,
                foerderung_2: foerderung2,
                foerderung_3: foerderung3,
                calculatedValues,
                projectRooms,
                planungscode: planungsCode || pCode,
                pdfLogo: '<svg xmlns="http://www.w3.org/2000/svg" width="125.832" height="41.78" viewBox="0 0 125.832 41.78"><defs><style>.a{fill:#08a7e1;}</style></defs><g transform="translate(-7.9 -6.2)"><path class="a" d="M33.714,18.428V6.2H27.6V41.149h6.114V26.732A6.327,6.327,0,0,1,35,22.957a6.611,6.611,0,0,1,1.812-1.434A4.328,4.328,0,0,1,38.7,21.07a16.418,16.418,0,0,1,1.963.075,2.912,2.912,0,0,1,1.661.83,3.6,3.6,0,0,1,.906,1.661,6.042,6.042,0,0,1,.226,2.34V41.149h6.114V24.316a11.626,11.626,0,0,0-.453-3.246,3.155,3.155,0,0,0-.3-.755c-.075-.075-.151-.377-.377-.755A9.377,9.377,0,0,0,46.4,17.372a8.788,8.788,0,0,0-3.774-1.585,9.249,9.249,0,0,0-1.434-.151,9.324,9.324,0,0,0-3.246.3,8.038,8.038,0,0,0-3.774,2.038Z" transform="translate(-4.83)"/><path class="a" d="M161.463,23.092v-3.85H155.5V44.3h5.963V30.339a4.521,4.521,0,0,1,1.812-3.85,6.252,6.252,0,0,1,3.246-1.359,8.539,8.539,0,0,1,3.4.151v-6.19a11.838,11.838,0,0,0-4,.377,8.779,8.779,0,0,0-2.642,1.359,10.39,10.39,0,0,0-1.812,2.265" transform="translate(-36.185 -3.154)"/><path class="a" d="M136.767,39.29a6.485,6.485,0,0,1-7.246-1.434,7.663,7.663,0,0,1-1.812-4.831h18.343c.151-2.189.075-5.963-1.585-8.832a11.139,11.139,0,0,0-7.473-5.51,12.407,12.407,0,0,0-8.077.755,11.34,11.34,0,0,0-5.661,5.284A14.693,14.693,0,0,0,121.9,31.44a15.675,15.675,0,0,0,.981,6.19,13.29,13.29,0,0,0,2.717,4.076,13.014,13.014,0,0,0,4.755,2.717,15.968,15.968,0,0,0,6.265.3,12.1,12.1,0,0,0,6.869-3.7,11.14,11.14,0,0,0,2.642-5.435v-.226h-6.265a5.8,5.8,0,0,1-3.095,3.925m-5.586-15.776a6.009,6.009,0,0,1,5.963.226c2.34,1.51,2.717,3.019,2.793,4.529H128.086a5.566,5.566,0,0,1,3.095-4.756" transform="translate(-27.944 -2.972)"/><path class="a" d="M81.986,44.183a6.293,6.293,0,0,1-1.359-3.623V25.387a5.22,5.22,0,0,0-2.189-4.68l-.226-.151a9.692,9.692,0,0,0-3.774-1.51,15.408,15.408,0,0,0-4.529-.453,23.042,23.042,0,0,0-4.529.453A8,8,0,0,0,60.4,22.293a9.557,9.557,0,0,0-1.208,4.982h5.888a4.375,4.375,0,0,1,.755-2.717c.83-.83,2.038-1.208,4.529-1.283a6.445,6.445,0,0,1,3.17.6,2.176,2.176,0,0,1,1.208,1.963,2.324,2.324,0,0,1-.226,1.434,1.321,1.321,0,0,1-1.057.528l-5.51,1.057a35.454,35.454,0,0,0-5.586,1.359,7.777,7.777,0,0,0-3.7,3.246,6.969,6.969,0,0,0-.6,4.454,6.894,6.894,0,0,0,2.793,4.529,10.526,10.526,0,0,0,5.359,1.963,12.6,12.6,0,0,0,4.454-.377,10.035,10.035,0,0,0,4-2.265v2.265H81.91v.151ZM72.4,38.824a7.893,7.893,0,0,1-5.963.83A3.3,3.3,0,0,1,64.1,36.71a2.774,2.774,0,0,1,1.283-2.491,10.751,10.751,0,0,1,1.887-.906c1.132-.3,3.4-.906,4.529-1.057.906-.151,1.812-.377,2.717-.6V34.6A4.17,4.17,0,0,1,72.4,38.824" transform="translate(-12.264 -3.034)"/><path class="a" d="M107.068,19.2v2.34a10.01,10.01,0,0,0-6.567-2.642,11.229,11.229,0,0,0-6.869,1.963,10.333,10.333,0,0,0-4.3,7.322c-.528,3.774-.151,7.171,1.736,9.964a10.275,10.275,0,0,0,8.756,4.68,11.274,11.274,0,0,0,7.171-2.566V43.5s.377,3.246-4.529,3.4S96.5,45.464,96.349,44.03H89.933v.3a6.438,6.438,0,0,0,3.095,5.057c4.3,2.717,12.606,1.359,12.606,1.359,4.3-.83,5.812-3.246,5.812-3.246a6.278,6.278,0,0,0,1.208-4V19.2Zm-2.114,17.512a6.027,6.027,0,0,1-7.624.075s-2.566-1.963-2.415-6.492,2.944-5.586,3.321-5.737a6.389,6.389,0,0,1,6.794.83,5.217,5.217,0,0,1,1.51,2.265,11.332,11.332,0,0,1,.377,2.793v.377c.226,2.265.075,4.3-1.963,5.888" transform="translate(-19.91 -3.107)"/><path class="a" d="M17.034,28.769a2.271,2.271,0,0,1-2.265,2.265h-4.6A2.271,2.271,0,0,1,7.9,28.769v-4.6A2.271,2.271,0,0,1,10.165,21.9h4.6a2.271,2.271,0,0,1,2.265,2.265Z" transform="translate(0 -3.849)"/><path class="a" d="M17.034,47.369a2.271,2.271,0,0,1-2.265,2.265h-4.6A2.271,2.271,0,0,1,7.9,47.369v-4.6A2.271,2.271,0,0,1,10.165,40.5h4.6a2.271,2.271,0,0,1,2.265,2.265Z" transform="translate(0 -8.409)"/></g></svg>',
                fontColor: [[0, 71, 126], [0, 170, 225], [74, 74, 74]],
                font: 'helvetica',
                coverPicture: "",
                imgPrefix: "https://www.projekt14.de/austausch/quick_h/",
                isHager: true
            },
            ["imgPrefix", "coverPicture", "font", "fontColor", "pdfLogo", "productCategories", "name", "id", "projectType", "products", "rooms","Artikelnummer", "Bezeichnung", "Gtin" , "Preis" , "UID-Pro", "count", "kategorie", "foerderung_1" , "foerderung_2" , "foerderung_3", "calculatedValues", "projectRooms", "selectedDesign", "selectedColor1", "selectedColor2", "colorId", "colorName", "finishName", "materialName", "selectedSerie", "planungscode", "isHager"]);


        fetch(
            process.env.REACT_APP_QUICK_BACKEND_URL + "/download/pflichtenheft_quick",
            {
                method: "post",
                body: products
            }
        ).then( (res)  => {
            res.blob().then((blob) => {
                const d = new Date();
                d.toLocaleString();
                let year = d.getFullYear();
                let month = d.getMonth();
                let day = d.getDate();

                month += 1;
                let filename = "HAGER";
                if (project.projectType === "knx") { filename += '-KNX_'; }
                else if (project.projectType === "konventionell") { filename += '_'; }
                else if (project.projectType === "home") { filename += '-HOME_'; }
                else { filename += '_'; }
                let projectname = project.projectName || project.name;
                projectname = projectname.split(' ').join('_');
                projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
                filename += "Raumbuch_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
                filename+= ".pdf";

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    "download",
                    filename,
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoadingRoomBook(false);
                })
            }
        )
        ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedRoomBook: 1}, undefined, trackingObj);
    }

    function downloadCSV(){
        if (!planungsCode && !pCode) {
            callFunction = 'downloadCSV';
            saveProject();
            return;
        }
        saveIdTracking('btn_project_cta', 'btn_project_get_article_list');
        let jsonData = "Lfd.Nr.;" + (productListAndFilters.isAllRooms ? 'Raum;' : "") + "Artikelnummer;Bezeichnung;UVP in €;Anzahl;Summe in €;\n";
        let lfdnr = 0;
        setLoadingCSV(true);

        productListAndFilters.productList.forEach( g => {
            g.products.forEach(p => {
                lfdnr += 1;
                let gesamtpreis = round(p.Preis / 100 * p.count);
                let formatierterPreis = round(p.Preis / 100);
                let formatierteBezeichnung = keineUmlaute(p.Bezeichnung);
                if (!productListAndFilters.isAllRooms) {
                    jsonData += lfdnr + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                } else {
                    jsonData += lfdnr + ";" + (p.floorName + ' - ' + p.roomName) + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                }
            })
        })
        jsonData += "\n";
        let extraChar = productListAndFilters.isAllRooms ? ';' : '';
        if(currentProject.projectType === 'knx' || currentProject.projectType === 'easy' ){
            jsonData += ";;;;Summe (netto);" + nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;MwSt (19%);" + mwst + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + gesamtsummeohnebeg + "" + extraChar + "\n";
            jsonData += ";;;;BEG-Foerderung;" + beg + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + gesamtsumme + "" + extraChar + "\n";
        }else if (currentProject.projectType === 'konventionell'){
            jsonData += ";;;;Summe (netto);" + nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;MwSt (19%);" + mwst + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + gesamtsummeohnebeg + "" + extraChar + "\n";
        }
        //insert planungsCode with an empty line
        jsonData += ";;;;;\n";
        jsonData += ";;Planungscode: " + (planungsCode ? planungsCode : pCode) + ";;;" + extraChar + "\n";
        jsonData += ";;Raum: " + (productListAndFilters.room !== 'alle' ? productListAndFilters.room : "St\u00fcckliste Produktebene") + ";;;" + extraChar + "\n";
        jsonData += ";;Produkt: " + (productListAndFilters.product ? productListAndFilters.product : "alle Produkte") + ";;;" + extraChar + "\n";

        let csvFile = "data:text/csv;charset=utf-8,";

        csvFile = jsonData;

        const d = new Date();
        d.toLocaleString();

        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();

        month += 1;

        let filename = "HAGER";
        if (project.projectType === "knx") { filename += '-KNX_'; }
        else if (project.projectType === "konventionell") { filename += '_'; }
        else if (project.projectType === "home") { filename += '-HOME_'; }
        else { filename += '_'; }
        let projectname = project.projectName || project.name;
        projectname = projectname.split(' ').join('_');
        projectname = projectname.split(' ').join('_');
        projectname = projectname.split('.').join('_');
        projectname = projectname.split('.').join('_');
        projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
        filename += "Stueckliste_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
        filename += ".csv";

        let blob = new Blob(["\ufeff" + csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoadingCSV(false);
            }
        }
        ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedCsv: 1}, undefined, trackingObj);
    }
    function CSVFree() {
        return <>Stückliste</>;
    }
    function CSVBusy() {
        return <div className="btn_loading"></div>;
    }
    function getCSVButtonLabel() {
        if (loadingCSV) { return <CSVBusy/>; }
        return <CSVFree/>;
    }
    function RoomBookFree() {
        return <>Raumbuch</>;
    }
    function RoomBookBusy() {
        return <CSVBusy/>;
    }
    function getRoomBookButtonLabel() {
        if (loadingRoomBook) { return <RoomBookBusy/>; }
        return <RoomBookFree/>;
    }
    function sendElbridge() {
        if (!planungsCode && !pCode) {
            saveProject();
        }
        let sendItem = {
            CONFIGURATION_URL: window.location.href,
            ITEM: [],
        };
        productListAndFilters.productList.map(lst => {
            lst.products.map(p => {
                sendItem.ITEM.push({
                    SUPPLIER_ID_GLN: "" + p.SUPPLIER_ID_GLN, //p.Gtin,
                    MANUFACTURER_PID: "" + p.Artikelnummer,
                    QUANTITY: "" + p.count,
                    ORDER_UNIT: "C62"
                });
                return p;
            });
            return lst;
        });
        let form = document.createElement('form');
        form.setAttribute('target', '_blank');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', 'https://interface.elbridge2.itek.de/');

        let inputEl = document.createElement("input");
        inputEl.setAttribute('type', 'text');
        inputEl.setAttribute('name', 'version');
        inputEl.setAttribute('value', '2.0');
        form.appendChild(inputEl);

        let inputData = document.createElement("input");
        inputData.setAttribute('type', 'text');
        inputData.setAttribute('name', 'result');
        inputData.setAttribute('value', JSON.stringify(sendItem));
        form.appendChild(inputData);

        console.log('sendItem', sendItem)

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            elbridgeUsed: 1
        }, null, trackingObj);
    }

    const ColorButton5 = withStyles((theme) => ({
        root: {
            color: "var(--borderColor)",
            backgroundColor: "transparent",
            border: "2px solid var(--borderColor)",
            '&:hover': {
                borderColor:"var(--blue)",
            },
            '&.active': {
                borderColor:"var(--blue)",
            },
            cursor: "pointer",
            alignContent: "center",
            height: "unset",
            padding: "23px",
            fontSize: "16px",
            fontWeight: "400",
            marginTop: "0",
            marginRight: "2%",
            marginLeft: "2%",
            textAlign: "center",
            borderRadius: "0",
            textTransform: "inherit",
            width: "46%",
        },
    }))(Button);
    const ColorButton5active = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--color1)",
            '&:hover': {
                backgroundColor:"var(--color1)",
                color: "var(--weiss)",
            },
            cursor: "pointer",
            height: "10px",
            alignContent: "center",
            padding: "25px",
            fontSize: "16px",
            fontWeight: "bold",
            marginTop: "0",
            textAlign: "center",
            borderRadius: "0",
            textTransform: "inherit",
        },
    }))(Button);
    const HtmlTooltip2 = withStyles((theme) => ({
        tooltip: {
            backgroundColor: "var(--weiss)",
            color: "var(--color2)",
            fontSize: "14px",
            border: '1px solid transparent',
            maxWidth: '400px',
            minWidth: '130px',
            padding: "0px 7px",
            textAlign: "center",
            boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
        },
    }))(Tooltip);

    function copyInClipboard(c) {
        var textField = document.createElement('textarea')
        textField.style.position = 'absolute';
        textField.style.left = '-100000px';
        textField.innerText = c;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setInClipboard(true);
    }
    function InClipboardNotice() {
        setTimeout(() => { setInClipboard(false); }, 1000);
        return <div className={"inClipboardNotice"}>Link kopiert</div>;
    }
    function CopyIconSVG() {
        return <HtmlTooltip2 title={<><p className={"copy-link-tooltip"}>Link kopieren</p></>}>
        <svg viewBox="0 0 294 275.33" width="24" height="24" fill="var(--color1)" onClick={e => copyInClipboard(planungsCode)}
             style={{marginLeft: "5px", position: "relative", top: "3px", cursor: "pointer"}}
        >
            <path className="b"
                  d="M257.11,89.81h-123.87c-20.35,0-36.89,15.71-36.89,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h123.87c20.35,0,36.89-15.71,36.89-35.03V124.84c0-19.32-16.54-35.03-36.89-35.03Zm18.16,150.49c0,8.99-8.15,16.3-18.16,16.3h-123.87c-10.02,0-18.16-7.31-18.16-16.3V124.84c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v115.47Z"/>
            <path className="b"
                  d="M50.65,166.79h-13.76c-10.02,0-18.16-7.32-18.16-16.31V35.03c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v12.83c0,5.17,4.19,9.36,9.36,9.36s9.36-4.19,9.36-9.36v-12.83C197.65,15.71,181.11,0,160.76,0H36.89C16.54,0,0,15.71,0,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h13.76c5.17,0,9.36-4.19,9.36-9.36s-4.19-9.36-9.36-9.36Z"/>
        </svg>
        </HtmlTooltip2>;
    }

    function setPC(c) {
        setPlanungsCode(c);
        pCode = c;
        if (callFunction === 'downloadCSV') { downloadCSV(); callFunction = ''; }
    }
    function saveProject(fromButton = false){
        if (fromButton) { saveIdTracking('btn_project_cta', 'btn_project_get_code'); }
        console.log('currentProject', currentProject)
        ProjectSaveService.saveTracking({
            trackingId: trackingObj ? trackingObj.trackingId : '',
            saved: trackingObj ? trackingObj.finalStep : {}
        }, undefined, trackingObj);
        ProjectSaveService.saveProject({...project, isExpert: isExpertForSave}, currentProject.projectPro, setPC);
    }
    function GetArrowForwardIcon() {
        return <img src={downloadIcon} width="20" alt={"download"} />;
    }
    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: "var(--weiss)",
            color: "var(--color2)",
            fontSize: "14px",
            border: '1px solid #dadde9',
            maxWidth: '250px',
            minWidth: '150px',
            boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
        },
    }))(Tooltip);

    useEffect(() => {
        document.title = 'Hager easyplan - Schritt 6';
        updateQueryParams('step_6', document.title);
        gaPageTracker((isExpertForSave ? '/expert' : '/customer') + '/page_6');
    }, []);
    function setFoerderung(id, value) {
        switch (id) {
            case 1: saveIdTracking('cb_project_setting', 'cb_project_include_subsidy'); setFoerderung1(value); break;
            case 2: saveIdTracking('cb_project_setting', 'cb_project_modern_heating'); setFoerderung2(value); break;
            case 3: saveIdTracking('cb_project_setting', 'cb_project_larger_plan'); setFoerderung3(value); break;
        }
    }

    return <>
        <div className={"section-container"} style={{paddingTop: '0'}}>
            <div className={"section-title"}>Zusammenfassung</div>
            <div className={"section-sub-title"}>Sie haben Ihre Konfiguration erfolgreich abgeschlossen. Im Folgenden erhalten Sie Informationen zu Ihrem Projekt (Kosteneinschätzung, mögliche Förderungen, Stückliste etc.).</div>
        </div>
        <div className={"section-container"} style={{paddingTop: '0'}}>
            {project.projectType !== 'konventionell' ? <>
                <div className={"section-title"}>Konfigurationsart ändern</div>
                <div className={"section-sub-title"}>Sie haben sich für eine smarte Installationsart entschieden. Diese basiert auf einer Konfiguration mit dem Hager easyTool. Diese Installation kann jederzeit in eine ETS-Konfiguration geändert werden.</div>
                <div className={"system-select-wrapper row"}>
                        <ColorButton5 onClick={e => updateProjectLocal({...project, projectType: "easy"})}
                                      className={"ob_configuration_type system-select-button" + (project.projectType === 'easy' ? " active" : '')}
                                      id={"ob_configuration_knx_easy"}
                        >
                            <img src={project.projectType === 'easy' ? radioChecked : radioUnchecked} width="24" alt={"radio"} />
                            <div className={"title"} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <span style={{display: 'inline-flex'}}>KNX easy</span>
                                <HtmlTooltip title={<div style={{padding: "25px", color: 'var(--blueColor)'}}>
                                    <p>easy bedeutet leicht - und entspricht dem Kern der Software. Mit easy lässt sich eine KNX-Anlage leicht, schnell und intuitiv konfigurieren. Dazu benötigen Sie einen easy-Konfigurationsserver, ein Tablet und die easy-App. Jede easy-Konfiguration können Sie durh quicklink-Funklösungen erweitern.</p>
                                        <p>Und: Jede Konfiguration kann vollständig in die ETS-Software importiert werden. So ist der Übergang zu einer größeren und noch leistungsfähirgeren KNX-Anlage jederzeit problemlos möglich. </p>
                                </div>}>
                                    <span className="info-icon" style={{display: 'inline-flex'}}>
                                        <img src={iIcon} width="32" height="32" alt={"info"} style={{margin: '0'}} />
                                    </span>
                                </HtmlTooltip>
                            </div>
                        </ColorButton5>
                        <ColorButton5 onClick={e => updateProjectLocal({...project, projectType: "knx"})}
                                      className={"ob_configuration_type system-select-button" + (project.projectType === 'knx' ? ' active' : '')}
                                      id={"ob_configuration_knx_ets"}
                        >
                            <img src={project.projectType === 'knx' ? radioChecked : radioUnchecked} width="24" alt="radio" />
                            <div className={"title"} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <span style={{display: 'inline-flex'}}>KNX ETS</span>
                                <HtmlTooltip title={<div style={{padding: "25px", color: 'var(--blueColor)'}}>
                                    <p>Die standardisierte Software KNX ETS eignet sich für die Installation größerer KNX- bzw. Smart Home-Systemen oder noch  komplexeren Anforderungen. Mit KNX ETS lassen sich zahlreiche erweiterte Funktionen projektieren, die sich besonders für Highend-Lösungen der Gebäudeautomation für den Wohn- und Zweckbau anbieten.</p>
                                </div>}>
                                    <span className="info-icon" style={{display: 'inline-flex'}}>
                                        <img src={iIcon} width="32" height="32" alt={"info"} style={{margin: '0'}} />
                                    </span>
                                </HtmlTooltip>
                            </div>
                        </ColorButton5>
                </div>
            </> : null}
        </div>
        <div className={"section-container"}>
            <div className={"preisbox"}>
                <div className={"row"} style={{marginTop: "15px"}}>
                    <div className={"col-1 section-title blue"} style={{fontSize: "18px", fontWeight: "bold", minWidth: "21%"}}>
                        Gesamtpreis UVP *
                    </div>

                    {/*<div className={"col-3 section-title blue"} style={{textAlign: "right", color: "var(--color2)", fontSize: "18px", fontWeight: "bold", minWidth: "35%"}}>*/}
                    {/*    Gesamtsumme{currentProject.projectType !== 'konventionell' ? " mit Förderung" : ""}:*/}
                    {/*</div>*/}
                    <div className={"text-center col-4 section-title"} style={{textAlign: "right", color: "var(--textColor)", fontSize: "18px", fontWeight: "bold", maxWidth: "13%", minWidth: "13%"}}>
                        {gesamtsummeohnebeg} €
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "5px"}}>
                    <div className={"col-1 section-sub-title"} style={{minWidth: "50%", padding: '0'}}>
                        (Unverbindliche Preisempfelung des Herstellers)
                    </div>
                    <div className={"col-6"}></div>
                    <div className={"text-center col-3"} style={{textAlign: "right", maxWidth: "13%"}}>
                        <span style={{fontWeight: "normal"}}>inkl. MwSt (19%)</span>
                    </div>
                    {/*<div className={"text-center col-4 section-title"} style={{textAlign: "right", color: "var(--textColor)", fontSize: "18px", fontWeight: "bold", maxWidth: "13%", minWidth: "13%"}}>*/}
                    {/*    {foerderung1 ? gesamtsumme : gesamtsummeohnebeg} €*/}
                    {/*</div>*/}
                </div>
                {/*<div className={"row"} style={{marginTop: "0"}}>*/}
                {/*    <div className={"col-1 section-sub-title"} style={{minWidth: "50%"}}></div>*/}
                {/*    <div className={"col-6"}></div>*/}
                {/*    <div className={"text-center col-3"} style={{textAlign: "right", maxWidth: "13%"}}>*/}
                {/*        <span style={{fontWeight: "normal"}}>inkl. MwSt (19%)</span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className={"col-1"} style={{textAlign: "left", maxWidth: "55%", minWidth: "55%", fontSize: "12px", paddingTop: '15px'}}>
                    *Die unverbindliche Preisempfehlung bezieht sich auf die reinen Materialkosten. Bitte beachten Sie, dass weitere Arbeitsschritte und Komponenten (z.B. Verteilung, Montage, Installation, Kabel oder Inbetriebnahme) im Preis nicht enthalten sind. Technische Änderungen vorbehalten.
                </div>
                <div className={"row"} style={{marginTop: "30px"}}>
                    <div className={"col-12 section-title blue"} style={{fontSize: "18px", fontWeight: "bold", minWidth: "21%"}}>
                        Unser Hager Tipp: Doppelt sparen mit der BEG Förderung für smarte Lösungen mit KNX easy und KNX ETS.
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "0"}}>
                    <div className={"text-center col-12 section-sub-title"} style={{textAlign: "left", color: "var(--textColor)", width: "100%", fontSize: "12px"}}>
                        Smarte Lösungen mit KNX easy und KNX ETS reduzieren nicht nur den Energieverbrauch, sondern werden auch aktiv durch die Bundesförderung für effiziente Gebäude (BEG) gefördert. Erfahren Sie hier mehr über die “BEG” der <a href="https://hager.com/de/wissen/gesetze-und-foerderungen/beg-bundesfoerderung-energieeffiziente-gebaeude" target={"_blank"}>BAFA - Förderprogramm im Überblick</a>.
                    </div>
                </div>
            </div>
        </div>
        <div className={"section-separator"}></div>
        {/*currentProject.projectType !== 'konventionell' ? <div className={"foerderung"}>
            <div className="section-container">
                <div className={"preisbox"}>
                    <div className={"fs-box-white-30-white-no-padding foerderbox"}>
                        <div className={"row"} style={{marginTop: "0"}}>
                            <div className={"title"} style={{color: "var(--color2)", fontSize: "18px"}}>BEG Förderungen für smarte Funktionen und mehr**</div>
                            <div className={"col-1"} style={{textAlign: "right", color: "var(--textColor)", marginTop: "0%", fontSize: "18px", fontWeight: "bold"}}>- {beg} €<br/><span style={{fontSize: "12px", position: "relative", top: "-5px", fontWeight: "normal", color: "var(--textColor)"}}>inkl. MwSt (19%)</span></div>
                        </div>
                        <div className={"row"} style={{marginTop: '0'}}>
                            <div className={"col-1"} style={{marginTop: "-1%", maxWidth: "50px"}}>
                                <Checkbox checked={foerderung1} color="default" onChange={e => setFoerderung(1, e.currentTarget.checked)} id={"cb_project_include_subsidy"} className={"foerderungsChecker cb_project_setting"} />
                            </div>
                            <div className={"col-2"} style={{textAlign: "left", minWidth: "60%"}}>
                                <div className={"bold"} style={{fontSize: "12px", marginBottom: "0.5%"}}>Alle smarten Funktionen Ihrer KNX oder easy Planung werden mit 20% gefördert.</div>
                                <div className={""} style={{fontSize: "12px"}}><a href="https://www.bafa.de/DE/Energie/Effiziente_Gebaeude/effiziente_gebaeude_node.html" target="_blank" style={{fontSize: "12px", color: "var(--textColor)", fontStyle: "normal"}} rel="noreferrer">Mehr Informationen</a></div>
                            </div>
                            <div className={"col-3"} style={{textAlign: "right", color: "var(--color2)", marginTop: "1.1%"}}></div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-1"} style={{marginTop: "-1%", maxWidth: "50px"}}>
                                <Checkbox checked={foerderung2} color="default" onChange={e => setFoerderung(2, e.currentTarget.checked)} id={"cb_project_modern_heating"} className={"foerderungsChecker cb_project_setting"} />
                            </div>
                            <div className={"col-2"} style={{textAlign: "left", minWidth: "60%"}}>
                                <div className={"bold"} style={{fontSize: "12px", marginBottom: "0.5%"}}>Sie modernisieren Ihre Heizungsanlage?</div>
                                <div className={""} style={{fontSize: "12px"}}>Die Modernisierung der Heizungsanlage (u.a. Wärmepumpe) mit smart geregelten Heizungsthermostaten und Steuerung (via App | zentrales Panel) werden mit 35% gefördert.</div>
                            </div>
                            <div className={"col-3"} style={{textAlign: "right", color: "var(--color2)", marginTop: "1.1%"}}></div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-1"} style={{marginTop: "-1%", maxWidth: "50px"}}>
                                <Checkbox checked={foerderung3} color="default" onChange={e => setFoerderung(3, e.currentTarget.checked)} id={"cb_project_larger_plan"} className={"foerderungsChecker cb_project_setting"} />
                            </div>
                            <div className={"col-2"} style={{textAlign: "left", minWidth: "60%"}}>
                                <div className={"bold"} style={{fontSize: "12px", marginBottom: "0.5%"}}>Sie setzen Ihr Projekt mit einem individuellen Sanierungsfahrplan um?</div>
                                <div className={""} style={{fontSize: "12px"}}>Dies wird mit weiteren 5% gefördert.</div>
                            </div>
                            <div className={"col-3"} style={{textAlign: "right", color: "var(--color2)", marginTop: "1.1%"}}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"section-separator"}></div>
            <div className="section-container">
            <div className={"preisbox"} style={{marginBottom: '15px'}}>
                <div className={"row"} style={{marginTop: "0"}}>
                    <div className={"col-1"} style={{textAlign: "left", maxWidth: "40%", minWidth: "40%", fontSize: "12px"}}></div>
                    <div className={"col-5"} style={{textAlign: "right", color: "var(--color2)", fontSize: "18px", fontWeight: "bold", minWidth: "35%", paddingRight: "0"}}>
                        Gesamtsumme ohne Förderung:<br/>
                        <span style={{color: 'var(--textColor)'}}>{gesamtsummeohnebeg} €</span><br/>
                        <span style={{fontSize: "12px", position: "relative", top: "-5px", fontWeight: "normal", color: "var(--textColor)"}}>inkl. MwSt (19%)</span>
                    </div>
                </div>
            </div>
            <div className={"section-separator"}></div>
            <div className={"preisbox"}>
                <div className={"row"} style={{marginTop: "0"}}>
                    <div className={"col-1"} style={{textAlign: "left", maxWidth: "100%", minWidth: "55%", fontSize: "12px"}}>
                        *Die unverbindliche Preisempfehlung bezieht sich auf die reinen Materialkosten. Bitte beachten Sie, dass weitere Arbeitsschritte und Komponenten (z.B. Verteilung, Montage, Installation, Kabel oder Inbetriebnahme) im Preis nicht enthalten sind. Technische Änderungen vorbehalten.
                    </div>
                </div>
                <div className={"row"} style={{marginTop: '5px'}}>
                    <div className={"col-1"} style={{textAlign: "left", maxWidth: "100%", minWidth: "40%", fontSize: "12px"}}>
                        ** Um die Förderung zu beantragen, benötigen Sie einen von der BAFA zertifizierten Energieberater. Der Antrag kann entweder direkt bei der BAFA gestellt werden oder bei der KFW zwecks Förderkredit mit gleichem Förderzuschuss (Stand 02/2022).
                    </div>
                </div>
            </div>
        </div>
        </div> : <></>*/}
        <div className={"section-container"}>
            <div className={"section-title"}>Produktliste</div>
            <div className={"section-sub-title"}>Nachfolgend können Sie Ihre Produktliste einsehen. Diese können Sie nach verschiedenen Kriterien filtern und exportieren.</div>
            <div className={"step5SelectWrapper filterWrapper row"}>
                <div className={"step5SelectItem col-1"}>
                    <Select defaultValue="alle" id="ob_article_list_setting_per_room" style={{display:"block"}}
                            className={"ob_article_list_setting"}
                            IconComponent={(props) => (<ExpandMoreOutlined {...props}/>)}
                    >
                        {generateRoomFilter(productListAndFilters.roomFilterList)}
                    </Select>
                </div>
                <div className={"step5SelectItem col-1"}>
                    <Select defaultValue={"productFilter-all"} id="ob_article_list_setting_per_category" style={{display:"block"}}
                            className={"ob_article_list_setting"}
                            IconComponent={(props) => (<ExpandMoreOutlined {...props}/>)}
                    >
                        {generateProductFilter(productListAndFilters.catFilterList)}
                    </Select>
                </div>
            </div>
        </div>
        <div className={"section-container step6"}>
            {!productListAndFilters.isAllRooms ? generateGroupList() : generateRoomList()}
        </div>
        <div className={"section-container"}>
            <div className={"section-title"} style={{marginBottom: '45px'}}>Planungsunterlagen</div>
            <div className={"exportButtons row"}>
                <ColorButton4 className={"btn_project_cta"} id={"btn_project_get_article_list"} startIcon={!loadingCSV ? <GetArrowForwardIcon /> : null} onClick={downloadCSV} style={{marginLeft: project.isExpert ? '0' : 'auto'}}>{getCSVButtonLabel()}</ColorButton4>
                <ColorButton4 className={"btn_project_cta"} id={"btn_project_get_room_book"} type="submit" startIcon={!loadingRoomBook ? <GetArrowForwardIcon /> : null} onClick={downloadPdf} style={{marginRight: project.isExpert ? '5px' : 'auto'}}>{getRoomBookButtonLabel()}</ColorButton4>
                {project.isExpert ? <ColorButton4 startIcon={<GetArrowForwardIcon />} onClick={sendElbridge}>Elbridge 2.0</ColorButton4> : null}
            </div>
        </div>
        <div className={"section-container"}>
            <div className={"codeBoxFinish"}>
                <div className={"section-text"}>Ihr Hager Planungscode für einen erneuten Aufruf Ihrer Planung: </div>
                    { planungsCode ?
                        <>
                        <div style={{position: "relative"}}>
                            <span className={"bold"}>{planungsCode}</span>
                            <CopyIconSVG/>
                            {inClipboard ? <InClipboardNotice/> : null}
                        </div>
                        </> : <div style={{textAlign: "right"}}><ColorButton5active className={"btn_project_cta"} id={"btn_project_get_code"} onClick={e => saveProject(true)}>Code generieren</ColorButton5active></div>
                    }
            </div>
        </div>
        <div style={{ float:"left", clear: "both" }} ref={scrollToElementRef}></div>
        <Dialog open={noticeDialogOpen} onClose={handleNoticeDialogClose} PaperProps={{className: "notice-dialog"}}>
                <DialogContent dividers>
                    <div className={"notice-header"}>
                        <h2>Hinweis</h2>
                        <button className="MuiButtonBase-root MuiIconButton-root jss181" tabIndex="0" type="button" aria-label="close" onClick={handleNoticeDialogClose}>
                            <span className="MuiIconButton-label">
                                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root"></span>
                        </button>
                    </div>
                    <DialogContentText color={"inherit"}>
                        Am Ende der Seite können Sie einen Planungscode für den erneuten Aufruf erstellen und weitere Planungsunterlagen downloaden.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div autoFocus onClick={handleNoticeDialogButton} color="primary" className={"modalButton notice"} style={{fontWeight: "bold"}}>
                        Planungscode &amp; Unterlagen
                    </div>
                </DialogActions>
            </Dialog>
    </>;
}
